module.exports = __webpack_public_path__ + "static/img/24.b1a76e82.png";